<template>
  <div class="side-menu">
    <div class="logo">🐔 种鸡育种管理系统</div>
    <el-menu
      class="menu"
      :default-active="activeMenu"
      router
      background-color="#001529"
      text-color="#a6adb4"
      active-text-color="#ffffff"
    >
      <el-menu-item index="/">
        <span>首页</span>
      </el-menu-item>
      <template v-for="m in visibleModules" :key="m.key">
        <!-- 统计报表:可展开子菜单 -->
        <el-sub-menu v-if="m.isGroup" :index="m.path">
          <template #title>
            <span>{{ m.name }}</span>
          </template>
          <el-menu-item v-for="c in m.children" :key="c.key" :index="c.path">
            {{ c.name }}
          </el-menu-item>
        </el-sub-menu>
        <el-menu-item v-else :index="m.path">
          <span>{{ m.name }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { filterModules } from '@/config/modules'
import { getUser } from '@/api/auth'

const route = useRoute()
// 报表子路由时高亮对应子菜单项
const activeMenu = computed(() => route.path)
// 普通用户不展示「用户管理」等仅管理员菜单
const visibleModules = computed(() => {
  const user = getUser()
  return filterModules(user?.userType === 'ADMIN')
})
</script>

<style scoped>
.side-menu {
  height: 100%;
  background-color: #001529;
}
.logo {
  height: 60px;
  line-height: 60px;
  text-align: center;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  white-space: nowrap;
}
.menu {
  border-right: none;
}
</style>
